/* eslint-disable */
import PropTypes from 'prop-types';

const I18nPropTypes = {
  /**
   * Set the text-align on the component.
   */
  align: PropTypes.oneOf([`center`, `end`, `inherit`, `justify`, `left`, `right`, `start`]),

  /**
   * The `key` to use to find the `translation`
   */
  children: PropTypes.string.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf([`default`, `error`, `inherit`, `primary`, `secondary`, `textSecondary`]),

  /**
   * This is any data that may be required to aid in the translation
   */
  data: PropTypes.object,

  /**
   * If `true`, the text will have a bottom margin.
   */
  gutterBottom: PropTypes.bool,

  /**
   * If `true`, the text will not wrap, but instead will truncate with an ellipsis.
   */
  nowrap: PropTypes.bool,

  /**
   * If `true`, the text will have a bottom margin.
   */
  paragraph: PropTypes.bool,

  /**
   * The inline style to use for the Component
   */
  style: PropTypes.object,

  /**
   * Applies the css `text-transform`
   */
  textTransform: PropTypes.oneOf([`capitalize`, `inherit`, `initial`, `lowercase`, `none`, `unset`, `uppercase`]),

  /**
   * Applies the theme typography styles.
   */
  variant: PropTypes.oneOf([`body2`, `body1`, `button`, `caption`, `h4`, `h3`, `h2`, `h1`, `h5`, `h6`, `subtitle1`]),
};

export default I18nPropTypes;
